import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { useDispatch, useSelector } from 'react-redux';
import { getJobsList } from 'redux/reducers/classifications/selectors';
import { TJob } from 'redux/reducers/classifications/types';
import { getJobsRequest } from 'redux/reducers/classifications/reducer';
import { PAGE_SIZE } from 'services/constants/env';
import { tableStructure } from './tableStructure';

export const Classifications: FC = () => {
	const dispatch = useDispatch();
	const jobsList = useSelector(getJobsList);

	useEffect(() => {
		dispatch(getJobsRequest());
	}, [dispatch]);

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithoutFilter<TJob>
				tableStructure={tableStructure}
				items={jobsList}
				itemsIsLoading={false}
				handleAction={() => {}}
			/>
		</Box>
	);
};
